import { createContext, useContext, useState } from "react";

export const WHATSAPP_URL =
  "https://wa.me/393381178389?text=Ciao%2C%20vorrei%20informazioni%20sui%20corsi%20e%20tour%20a%20Manerba%20del%20Garda";

export const FLYER_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_a30664c0-d7c3-474c-8427-147c69b49c45/artifacts/o0fsel7b_IMG-20260729-WA0054.jpg";

export const FLYER_VELA_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_water-sports-reserve/artifacts/pute8hug_IMG-20260916-WA0028.jpg";

export const translations = {
  it: {
    nav: { experiences: "Esperienze", club: "Il Circolo", book: "Prenota ora", admin: "Area Staff" },
    hero: {
      eyebrow: "Circolo Vela · Manerba del Garda",
      l1: "Il lago da una",
      l2: "prospettiva",
      l3: "unica.",
      sub: "Kayak da turismo stabili e sicuri e kayak olimpici da gara per chi vuole migliorare tecnica e prestazione. Tutte le attività sono seguite da istruttori qualificati.",
      weather: "Vento Ora 11 kn · Acqua 22°C · Condizioni ottimali",
      coords: "45.5597° N — 10.5654° E",
      cta: "Prenota la tua uscita",
      flyer: "Vedi il volantino ufficiale",
      discount: "Residenti a Manerba del Garda: −20% su tutti i servizi, tessera club inclusa",
      scroll: "Scorri",
    },
    services: {
      eyebrow: "Catalogo 2026",
      title: "Corsi, tour e noleggi",
      sub: "Gli stessi prezzi del volantino ufficiale. Nessun pagamento online: blocchi il posto qui e saldi al circolo.",
      tabCorsi: "Corsi di Kayak",
      tabTour: "Escursioni",
      tabRental: "Uso Natanti",
      tabVela: "Corsi di Vela",
      book: "Prenota",
      perPerson: "a persona",
      month: "al mese",
      min: "min",
      people: "persone",
      tessera: "+ tessera socio €10",
      route: "Percorso",
      included: "Sicurezza e sacca waterproof incluse",
    },
    manifesto: {
      eyebrow: "Il manifesto",
      title: "Quattro motivi per pagaiare con noi",
      chapters: [
        {
          n: "01",
          title: "Il vento del Benaco e la Riserva",
          text: "Circondati dai promontori calcarei della Rocca e dalle acque limpide di Manerba, navighiamo a impatto zero in un'oasi protetta.",
        },
        {
          n: "02",
          title: "Istruttori certificati, sicurezza totale",
          text: "Ogni uscita è seguita da guide qualificate, con giubbotti certificati e controllo costante di meteo e venti di lago, Pelèr e Ora.",
        },
        {
          n: "03",
          title: "Prenoti online, paghi al circolo",
          text: "Nessuna carta di credito. Blocchi il tuo posto o il tuo kayak online, ricevi il codice di conferma e saldi in loco, carta o contanti.",
        },
        {
          n: "04",
          title: "Comunità locale: −20% ai residenti",
          text: "Chi vive il lago tutto l'anno merita un vantaggio: i residenti di Manerba del Garda hanno il 20% di sconto su ogni servizio.",
        },
      ],
    },
    booking: {
      eyebrow: "Prenotazione online",
      title: "Blocca il tuo posto sul lago",
      step1: "Scegli l'esperienza",
      step2: "Scegli la data",
      step3: "Scegli l'orario",
      step4: "Partecipanti",
      step5: "I tuoi dati",
      summary: "Riepilogo",
      spots: "posti",
      spotsLeft: "posti liberi",
      noSlots: "Nessuna disponibilità in questo mese",
      pickDate: "Seleziona prima una data",
      participants: "Persone",
      kayaks: "Kayak",
      hours: "Durata",
      hour: "ora",
      hours2: "ore",
      resident: "Sono residente a Manerba del Garda (−20%)",
      residentNote: "Lo sconto viene applicato al circolo dietro presentazione di un documento.",
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono / WhatsApp",
      notes: "Note o richieste speciali (muta, esigenze…)",
      submit: "Conferma la prenotazione",
      submitting: "Invio in corso…",
      noPayment: "Nessun pagamento online — pagherai al circolo il giorno dell'attività.",
      subtotal: "Subtotale",
      discount: "Sconto residenti −20%",
      tessera: "Tessera socio",
      total: "Totale da pagare al circolo",
      minNotice: "Questo tour richiede un minimo di {n} partecipanti.",
      successTitle: "Prenotazione confermata",
      successSub: "Presenta questo codice al circolo il giorno dell'attività. Ti aspettiamo sul molo!",
      code: "Codice prenotazione",
      when: "Quando",
      what: "Esperienza",
      who: "Partecipanti",
      whatsapp: "Conferma su WhatsApp",
      backHome: "Torna alla home",
      back: "Indietro",
      newBooking: "Nuova prenotazione",
      lang: "it",
    },
    cabinati: {
      eyebrow: "Esperienza Vela",
      title: "I nostri cabinati",
      sub: "Lasciati guidare dal vento e scopri la bellezza del lago a bordo dei nostri cabinati: barche a vela stabili, sicure e accoglienti, perfette per imparare a navigare o perfezionare la tecnica, sempre affiancati dai nostri istruttori esperti.",
      features: [
        "Pozzetto profondo e protetto, ideale anche per chi è alle prime armi",
        "Cabina interna con cuccette: riparo dal sole e spazio per i bagagli",
        "Chiglia stabile: la barca perdona gli errori e dà sicurezza",
        "Timone a barra, vele semplici da regolare e motore ausiliario a bordo",
        "Uscite con istruttore: pochi allievi per barca, tanta pratica al timone",
      ],
      note: "Certificato medico in corso di validità obbligatorio per la partecipazione ai corsi.",
      cta: "Prenota il corso di vela",
      captions: [
        "Il nostro cabinato NYTEC 25 al molo del circolo",
        "Il cabinato: stabile, sicuro, perfetto per imparare",
        "Sotto vela davanti a Limone sul Garda",
      ],
    },
    gallery: {
      eyebrow: "Dal vivo",
      title: "La sede e i tour, in foto vere",
      sub: "Niente immagini di repertorio: questi siamo noi, la nostra spiaggia e le nostre uscite sul Garda.",
      captions: [
        "La sede: scuola di pagaiata a riva",
        "Tour di gruppo verso l'Isola dei Conigli",
        "Sotto le falesie della Rocca di Manerba",
        "Partenza dalla spiaggia, anche per i più piccoli",
        "La baia di Manerba del Garda",
      ],
    },
    footer: {
      tagline: "Sport · Natura · Avventura — il kayak per tutti, in totale sicurezza.",
      contacts: "Contatti",
      where: "Via del Zocco 110, 25080 Manerba del Garda (BS) · Lago di Garda",
      rights: "Circolo Vela Manerba del Garda. Tutti i diritti riservati.",
      medical: "*Per i corsi è richiesto il certificato medico.",
    },
    months: ["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],
    days: ["Lu","Ma","Me","Gi","Ve","Sa","Do"],
  },
  en: {
    nav: { experiences: "Experiences", club: "The Club", book: "Book now", admin: "Staff Area" },
    hero: {
      eyebrow: "Sailing Club · Manerba del Garda",
      l1: "The lake from a",
      l2: "whole new",
      l3: "perspective.",
      sub: "Stable, safe touring kayaks and Olympic racing kayaks for those chasing technique and performance. Every activity is led by qualified instructors.",
      weather: "Ora wind 11 kn · Water 22°C · Perfect conditions",
      coords: "45.5597° N — 10.5654° E",
      cta: "Book your session",
      flyer: "View the official flyer",
      discount: "Manerba del Garda residents: 20% off every service, club card included",
      scroll: "Scroll",
    },
    services: {
      eyebrow: "2026 Catalogue",
      title: "Courses, tours & rentals",
      sub: "Same prices as the official flyer. No online payment: lock your spot here and settle at the club.",
      tabCorsi: "Kayak Courses",
      tabTour: "Guided Tours",
      tabRental: "Kayak Rental",
      tabVela: "Sailing Courses",
      book: "Book",
      perPerson: "per person",
      month: "per month",
      min: "min",
      people: "people",
      tessera: "+ club card €10",
      route: "Route",
      included: "Safety gear & dry bag included",
    },
    manifesto: {
      eyebrow: "The manifesto",
      title: "Four reasons to paddle with us",
      chapters: [
        {
          n: "01",
          title: "The Garda winds & the Reserve",
          text: "Framed by the limestone cliffs of the Rocca and Manerba's crystal water, we paddle emission-free inside a protected natural oasis.",
        },
        {
          n: "02",
          title: "Certified instructors, total safety",
          text: "Every outing is led by qualified guides with certified life jackets and constant monitoring of weather and lake winds, Pelèr and Ora.",
        },
        {
          n: "03",
          title: "Book online, pay at the club",
          text: "No credit card needed. Lock your kayak or tour spot online, get an instant booking code, and pay on arrival — card or cash.",
        },
        {
          n: "04",
          title: "Local community: residents −20%",
          text: "Those who live on the lake all year deserve an advantage: Manerba del Garda residents get 20% off every single service.",
        },
      ],
    },
    booking: {
      eyebrow: "Online booking",
      title: "Lock your spot on the lake",
      step1: "Pick your experience",
      step2: "Pick a date",
      step3: "Pick a time",
      step4: "Participants",
      step5: "Your details",
      summary: "Summary",
      spots: "spots",
      spotsLeft: "spots left",
      noSlots: "No availability this month",
      pickDate: "Select a date first",
      participants: "People",
      kayaks: "Kayaks",
      hours: "Duration",
      hour: "hour",
      hours2: "hours",
      resident: "I'm a Manerba del Garda resident (−20%)",
      residentNote: "The discount is applied at the club upon showing proof of residency.",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      notes: "Notes or special requests (wetsuit, needs…)",
      submit: "Confirm booking",
      submitting: "Sending…",
      noPayment: "No online payment — you'll pay at the club on the day of your activity.",
      subtotal: "Subtotal",
      discount: "Resident discount −20%",
      tessera: "Club card",
      total: "Total to pay at the club",
      minNotice: "This tour requires a minimum of {n} participants.",
      successTitle: "Booking confirmed",
      successSub: "Show this code at the club on the day of your activity. See you at the dock!",
      code: "Booking code",
      when: "When",
      what: "Experience",
      who: "Participants",
      whatsapp: "Confirm on WhatsApp",
      backHome: "Back to home",
      back: "Back",
      newBooking: "New booking",
      lang: "en",
    },
    cabinati: {
      eyebrow: "Sailing Experience",
      title: "Our cabin cruisers",
      sub: "Let the wind guide you and discover the beauty of the lake aboard our cabin cruisers: stable, safe and welcoming sailboats, perfect for learning to sail or refining your technique, always flanked by our expert instructors.",
      features: [
        "Deep, protected cockpit — ideal even for complete beginners",
        "Interior cabin with berths: shade from the sun and room for bags",
        "Stable keel: the boat forgives mistakes and builds confidence",
        "Tiller steering, easy-to-trim sails and an auxiliary engine on board",
        "Instructor-led outings: few students per boat, plenty of helm time",
      ],
      note: "A valid medical certificate is mandatory to join the courses.",
      cta: "Book the sailing course",
      captions: [
        "Our cabin cruiser NYTEC 25 at the club dock",
        "The cabin cruiser: stable, safe, perfect for learning",
        "Under sail in front of Limone sul Garda",
      ],
    },
    gallery: {
      eyebrow: "On the water",
      title: "Our base and tours, in real photos",
      sub: "No stock images: this is us, our beach and our outings on Lake Garda.",
      captions: [
        "The clubhouse: paddle school on the shore",
        "Group tour towards Rabbit Island",
        "Beneath the cliffs of Rocca di Manerba",
        "Beach launch — kids welcome too",
        "The bay of Manerba del Garda",
      ],
    },
    footer: {
      tagline: "Sport · Nature · Adventure — kayaking for everyone, in complete safety.",
      contacts: "Contacts",
      where: "Via del Zocco 110, 25080 Manerba del Garda (BS) · Lake Garda, Italy",
      rights: "Circolo Vela Manerba del Garda. All rights reserved.",
      medical: "*A medical certificate is required for courses.",
    },
    months: ["January","February","March","April","May","June","July","August","September","October","November","December"],
    days: ["Mo","Tu","We","Th","Fr","Sa","Su"],
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("it");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
